export var DocumentStatuses;
(function (DocumentStatuses) {
    DocumentStatuses["processing"] = "processing";
    DocumentStatuses["validated"] = "validated";
    DocumentStatuses["ready"] = "ready";
    DocumentStatuses["review_ready"] = "review_ready";
})(DocumentStatuses || (DocumentStatuses = {}));
